import {UserRole} from "@/shared/enums/UserRolesEnums";
import AssistedLivingCoachingList from "@/views/App/Analytics/MontlyList/AssistedLivingCoaching/List.vue";


const routesAnalyticsMonthlyList = [
    {
        path: "assisted-living-coaching",
        name: "analyticsMonthlyListAssistedLivingCoaching",
        component: AssistedLivingCoachingList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    }
]

export default routesAnalyticsMonthlyList;